import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_7989_198446)">
      <path
        d="M1.09703 11.7353C1.27318 13.3818 2.59741 14.706 4.24308 14.8895C6.77084 15.1712 9.22923 15.1712 11.757 14.8895C13.4027 14.706 14.7269 13.3818 14.903 11.7353C15.0331 10.5198 15.1429 9.27201 15.1429 7.99983C15.1429 6.72765 15.0331 5.47982 14.903 4.26437C14.7269 2.61792 13.4027 1.29368 11.757 1.11024C9.22923 0.828487 6.77084 0.828487 4.24308 1.11024C2.59741 1.29368 1.27318 2.61792 1.09703 4.26437C0.966987 5.47982 0.857178 6.72765 0.857178 7.99983C0.857178 9.27201 0.966988 10.5198 1.09703 11.7353Z"
        fill={props?.fill ? '#CCCCCC' : '#383838'}
        stroke="white"
      />
      <path d="M8 5.14307V10.8574" stroke="white" strokeLinecap="round" />
      <path d="M10.8571 8H5.14282" stroke="white" strokeLinecap="round" />
    </g>
    <defs>
      <clipPath id="clip0_7989_198446">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const BlackAddIcon = memo(ForwardRef);
export default BlackAddIcon;
